import { Injectable } from '@angular/core';
import { OAuthService, TokenResponse } from 'angular-oauth2-oidc';

/**
 * OAuthService with a single-flight guard around token refresh.
 *
 * angular-oauth2-oidc fires one /connect/token POST per refreshToken() call.
 * Concurrent triggers (startup-expired check + token_expires event + queued
 * requests) would send the same refresh_token twice; OpenIddict redeems it on
 * the first use and the second update collides on ConcurrencyStamp, producing
 * AbpDbConcurrencyException server-side and forced logouts client-side.
 */
@Injectable()
export class SingleFlightOAuthService extends OAuthService {
  private refreshInFlight?: Promise<TokenResponse>;

  override refreshToken(): Promise<TokenResponse> {
    this.refreshInFlight ??= super.refreshToken().finally(() => {
      this.refreshInFlight = undefined;
    });
    return this.refreshInFlight;
  }
}
